/* P1 · Alttan çıkan yapışkan sepet çubuğu
   Ana ürün formunu kullanır; seçili varyant ve adet olduğu gibi gönderilir. */
if (!customElements.get('p1-sticky-atc')) {
  customElements.define(
    'p1-sticky-atc',
    class P1StickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-p1-sticky-btn]');
        this.priceEl = this.querySelector('[data-p1-sticky-price]');
        this.mainButton =
          document.querySelector('product-info .product-form__submit') ||
          document.querySelector('.product-form__submit');

        if (!this.mainButton || !this.button) {
          this.remove();
          return;
        }

        this.form = this.mainButton.form || this.mainButton.closest('form');
        this.defaultLabel = this.button.textContent.trim();

        this.button.addEventListener('click', this.onClick.bind(this));
        this.syncPrice();
        this.syncState();
        this.observe();
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.mo) this.mo.disconnect();
        if (this.btnMo) this.btnMo.disconnect();
        document.body.classList.remove('p1-sticky-visible');
      }

      observe() {
        this.io = new IntersectionObserver((entries) => {
          const entry = entries[0];
          const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.toggle(passed);
        });
        this.io.observe(this.mainButton);

        const priceSource = this.getPriceContainer();
        if (priceSource) {
          this.mo = new MutationObserver(() => this.syncPrice());
          this.mo.observe(priceSource, { childList: true, subtree: true, characterData: true });
        }

        this.btnMo = new MutationObserver(() => this.syncState());
        this.btnMo.observe(this.mainButton, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
      }

      getPriceContainer() {
        const scope = this.mainButton.closest('product-info') || document;
        return scope.querySelector('[id^="price-"]');
      }

      syncPrice() {
        const container = this.getPriceContainer();
        if (!container || !this.priceEl) return;
        const price = container.querySelector('.price');
        if (!price) return;
        const onSale = price.classList.contains('price--on-sale');
        const item = onSale
          ? price.querySelector('.price__sale .price-item--sale')
          : price.querySelector('.price__regular .price-item--regular');
        const text = item ? item.textContent.trim() : '';
        if (text) this.priceEl.textContent = text;
      }

      syncState() {
        const disabled = this.mainButton.hasAttribute('disabled');
        this.button.disabled = disabled;
        this.button.textContent = disabled ? this.dataset.labelSoldOut || this.defaultLabel : this.defaultLabel;
      }

      toggle(show) {
        this.classList.toggle('is-visible', show);
        this.setAttribute('aria-hidden', show ? 'false' : 'true');
        this.button.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('p1-sticky-visible', show);
      }

      onClick() {
        if (this.button.disabled) return;
        if (this.form && typeof this.form.requestSubmit === 'function') {
          this.form.requestSubmit(this.mainButton);
        } else {
          this.mainButton.click();
        }
      }
    }
  );
}
